import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';
import { makeSelectEntryContentVisible, entryContentShown } from '@dbh/with-entry-content';
import createUseBoundEventCreator from '@dbh/create-use-bound-event-creator';

/*
 *
 * Constants: `@dbh/hotel-map-entry-content`.
 *
 */const hotelMapEntryContentName="hotelMap";

/**
 * Returns a selector that returns the visibility of the hotel map entry content.
 * @return {boolean} `true` if the hotel map entry content is visible.
 */const makeSelectHotelMapEntryContentVisible=()=>makeSelectEntryContentVisible(hotelMapEntryContentName);var makeSelectHotelMapEntryContentVisible$1 = makeSelectHotelMapEntryContentVisible;

const hotelMapEntryContentShown=()=>entryContentShown({entryContentName:hotelMapEntryContentName});const useHotelMapEntryContentShown=createUseBoundEventCreator(hotelMapEntryContentShown);

var index = createBrowserOnlyLazyComponent(()=>import('./component-11fa8d25.js'/* webpackChunkName: "dbh.hotel-map-entry-content" */));

export { index as default, hotelMapEntryContentName, hotelMapEntryContentShown, makeSelectHotelMapEntryContentVisible$1 as makeSelectHotelMapEntryContentVisible, useHotelMapEntryContentShown };
